<template>
    <div>
        <headerNotice routerName='快递单模板'></headerNotice>
        
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data () {
        return {
            
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        
    },
    methods: {
        //打印
        print() {
            printJS({
                printable: 'printBox',
                type: 'html',
                // 继承原来的所有样式
                targetStyles: ['*']
            })
        },
        //返回
        back(){
            this.$router.back();
        }
    }
 }
</script>

<style lang='scss' scoped>
 .printOrderPage {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    .header {
        position: relative;
        .printBtn {
            position: absolute;
            top: -10px;
            right: 20%;
        }
    }
}
</style>